export const convertCamelCaseToSentence = (value: string) => {
  return value.replace(/([A-Z])/g, " $1").trim();
};

export const removeFileExtension = (value: string) => {
  const dotIndex = value.lastIndexOf(".");

  return dotIndex !== -1 ? value.substring(0, dotIndex) : value;
};
